import { X } from "@phosphor-icons/react";
import { BURST_COUNTS, BURST_GAPS_MS, TL_INTERVALS_S, TL_SHOTS } from "../lib/captureSettings";

const Row = ({ label, children }) => (
  <div className="mb-4">
    <p className="label-mono text-[10px] opacity-70 mb-2">{label}</p>
    <div className="flex flex-wrap gap-2">{children}</div>
  </div>
);

const Opt = ({ on, onClick, testid, children }) => (
  <button type="button" onClick={onClick} data-testid={testid}
    className={`min-w-[52px] h-10 px-3 border-2 font-mono text-xs font-bold transition-colors ${on ? "bg-white text-black border-white" : "bg-black text-white border-white/50"}`}>
    {children}
  </button>
);

export function CaptureSettingsSheet({ settings, onChange, onClose }) {
  const set = (k, v) => onChange({ ...settings, [k]: v });
  return (
    <div className="fixed inset-0 z-40 bg-black/80 flex items-end sm:items-center justify-center" onClick={onClose} data-testid="capture-settings-sheet">
      <div className="w-full sm:max-w-md bg-black border-t-2 sm:border-2 border-white p-5 safe-bottom" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-4">
          <p className="font-display font-bold text-lg">CAPTURE SETTINGS</p>
          <button onClick={onClose} className="w-10 h-10 bg-white text-black flex items-center justify-center" data-testid="capture-settings-close" aria-label="Close settings">
            <X size={18} weight="bold" />
          </button>
        </div>
        <Row label="BURST SIZE">
          {BURST_COUNTS.map((n) => (
            <Opt key={n} on={settings.burstCount === n} onClick={() => set("burstCount", n)} testid={`burst-count-${n}`}>×{n}</Opt>
          ))}
        </Row>
        <Row label="BURST SPACING">
          {BURST_GAPS_MS.map((ms) => (
            <Opt key={ms} on={settings.burstGapMs === ms} onClick={() => set("burstGapMs", ms)} testid={`burst-gap-${ms}`}>{ms / 1000}s</Opt>
          ))}
        </Row>
        <Row label="TIMELAPSE INTERVAL">
          {TL_INTERVALS_S.map((s) => (
            <Opt key={s} on={settings.tlIntervalS === s} onClick={() => set("tlIntervalS", s)} testid={`tl-interval-${s}`}>{s}s</Opt>
          ))}
        </Row>
        <Row label="TIMELAPSE STOPS AFTER">
          {TL_SHOTS.map((n) => (
            <Opt key={n} on={settings.tlShots === n} onClick={() => set("tlShots", n)} testid={`tl-shots-${n || "manual"}`}>{n ? `${n} shots` : "Manual stop"}</Opt>
          ))}
        </Row>
        <p className="font-mono text-[10px] opacity-60 leading-relaxed">
          SCANNER: a USB/Bluetooth barcode scan sets the SKU tag and fires a burst. SPACE/ENTER = shot · B = burst · hold shutter = burst.
        </p>
      </div>
    </div>
  );
}
